import { ParticipantFileStatusCode, TrainingDocumentStatusCode } from "../types/components";
import { DOCUMENT_STATUSES } from "./consts/documents";
import { TRAINING_DOCUMENT_STATUSES } from "./consts/trainingDocuments";

export const isStatusPendingApproval = (status: ParticipantFileStatusCode) =>
  status === DOCUMENT_STATUSES.pending_approval;

export const isStatusApproved = (status: ParticipantFileStatusCode) =>
  status === DOCUMENT_STATUSES.approved;

export const isStatusNotUploaded = (status: ParticipantFileStatusCode) =>
  status === DOCUMENT_STATUSES.not_uploaded;

export const isStatusNotApproved = (
  status: ParticipantFileStatusCode | TrainingDocumentStatusCode,
) => status === DOCUMENT_STATUSES.not_approved;

export const isTrainingDocumentStatusPendingApproval = (status: TrainingDocumentStatusCode) =>
  status === TRAINING_DOCUMENT_STATUSES.waiting_for_approval;

export const isTrainingDocumentStatusApproved = (status: TrainingDocumentStatusCode) =>
  status === TRAINING_DOCUMENT_STATUSES.approved;

export const isTrainingDocumentStatusRejected = (status: TrainingDocumentStatusCode) =>
  status === TRAINING_DOCUMENT_STATUSES.rejected;
